export default __webpack_public_path__ + "static/media/gitHubIcon.ee0f330d.png";